import { forwardRef, type ComponentProps, type CSSProperties, type ElementType } from "react";

import type { FieldError, Merge } from "react-hook-form";

import { cn } from "@eisox/design-system";

interface FieldContainerProps extends Omit<ComponentProps<"div">, "className" | "style"> {
  label?: React.ReactNode;
  error?: Merge<FieldError, (FieldError | undefined)[]> | FieldError;
  classNames?: {
    container?: string;
    label?: string;
    error?: string;
  };
  style?: {
    container?: CSSProperties;
    label?: CSSProperties;
    error?: CSSProperties;
  };
}

const FieldContainer: React.FC<FieldContainerProps> = forwardRef<HTMLDivElement, FieldContainerProps>(
  ({ label, error, classNames, style, children, ...props }, ref) => {
    const Tag = (label ? "label" : "div") as ElementType;
    return (
      <Tag {...props} ref={ref} className={cn("mb-0 flex flex-col", classNames?.container)} style={style?.container}>
        {label !== undefined && (
          <span
            style={style?.label}
            className={cn("mb-1.25 leading-6 font-medium text-base text-primary-dark-blue", classNames?.label)}
          >
            {label}
          </span>
        )}
        {children}
        {error?.message && (
          <p className={cn("text-base text-primary-red", classNames?.error)} style={style?.error}>
            {error.message}
          </p>
        )}
      </Tag>
    );
  },
);

FieldContainer.displayName = "FieldContainer";

export { FieldContainer };
export type { FieldContainerProps };
